import { createSlice } from '@reduxjs/toolkit';

interface SeatState {
    seats: any[];
    currentSeat: any | null;
    showSeats: any[];
    availableSeats: any[];
    loading: boolean;
}

const initialState: SeatState = {
    seats: [],
    currentSeat: null,
    showSeats: [],
    availableSeats: [],
    loading: false,
};

const seatSlice = createSlice({
    name: 'seat',
    initialState,
    reducers: {
        getSeats: (state) => {
            state.loading = true;
        },
        getSeatsSuccess: (state, action) => {
            state.seats = action.payload;
            state.loading = false;
        },
        getSeatsFailed: (state) => {
            state.loading = false;
        },
        getSeatById: (state) => {
            state.loading = true;
        },
        getSeatByIdSuccess: (state, action) => {
            state.currentSeat = action.payload;
            state.loading = false;
        },
        getSeatByIdFailed: (state) => {
            state.loading = false;
        },
        getSeatsByShowId: (state) => {
            state.loading = true;
        },
        getSeatsByShowIdSuccess: (state, action) => {
            state.showSeats = action.payload;
            state.loading = false;
        },
        getSeatsByShowIdFailed: (state) => {
            state.loading = false;
        },
        getAvailableSeats: (state) => {
            state.loading = true;
        },
        getAvailableSeatsSuccess: (state, action) => {
            state.availableSeats = action.payload;
            state.loading = false;
        },
        getAvailableSeatsFailed: (state) => {
            state.loading = false;
        },
        updateSeatStatus: (state) => {
            state.loading = true;
        },
        updateSeatStatusSuccess: (state, action) => {
            const index = state.seats.findIndex(seat => seat._id === action.payload._id);
            if (index !== -1) {
                state.seats[index] = action.payload;
            }
            state.loading = false;
        },
        updateSeatStatusFailed: (state) => {
            state.loading = false;
        },
        bookSeat: (state) => {
            state.loading = true;
        },
        bookSeatSuccess: (state, action) => {
            const index = state.seats.findIndex(seat => seat._id === action.payload._id);
            if (index !== -1) {
                state.seats[index] = action.payload;
            }
            state.loading = false;
        },
        bookSeatFailed: (state) => {
            state.loading = false;
        },
    },
});

export const {
    getSeats,
    getSeatsSuccess,
    getSeatsFailed,
    getSeatById,
    getSeatByIdSuccess,
    getSeatByIdFailed,
    getSeatsByShowId,
    getSeatsByShowIdSuccess,
    getSeatsByShowIdFailed,
    getAvailableSeats,
    getAvailableSeatsSuccess,
    getAvailableSeatsFailed,
    updateSeatStatus,
    updateSeatStatusSuccess,
    updateSeatStatusFailed,
    bookSeat,
    bookSeatSuccess,
    bookSeatFailed,
} = seatSlice.actions;

export default seatSlice.reducer; 